module.exports = __webpack_public_path__ + "static/media/3.902b9461.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/slides/201812/3.png
// module id = 641
// module chunks = 0